import type { IconName } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { minVisitsAbbrFilter, percentageSignFilter, simplePercentageFilter } from "app/filters/ngFilters";

export const POP_CURRENT_COLOR = colorsPalettes.blue[400];
export const POP_PREVIOUS_COLOR = colorsPalettes.orange[400];

export const CONVERSIONS_EXCEL_ENDPOINT = "api/ConversionRates/Overtime/Excel";
export const CONVERSIONS_TRACKING_PREFIX = "Over Time Graph/Conversions Over Time";

export const CONVERSION_METRICS = {
    convertedVisits: "convertedVisits",
    conversionRate: "conversionRate",
} as const;
export type ConversionMetric = (typeof CONVERSION_METRICS)[keyof typeof CONVERSION_METRICS];

export const CONVERSION_RATE_TRANSLATION_KEYS = {
    widgetTitle: "wa.conversions.over.time.widget.title",
    hookTitle: "wa.conversions.over.time.hook.title",
    hookCta: "wa.conversions.over.time.hook.cta",
    emptyUnavailableTitle: "wa.conversions.over.time.empty.title",
    emptyUnavailableDurationSubtitle: "wa.conversions.over.time.empty.duration.subtitle",
} as const;

/** ScorableTabs renders `dynamicFilter(value, format)`; NoneFilter is unknown to the filter registry so the value passes through verbatim. */
export const HEADLINE_PASSTHROUGH_FORMAT = "NoneFilter";
export const HEADLINE_DASH = "\u2014";

export type ConversionTab = {
    metric: ConversionMetric;
    title: string;
    tooltip: string;
    iconName: IconName;
    format: string;
};

export const CONVERSION_TABS: readonly ConversionTab[] = [
    {
        metric: CONVERSION_METRICS.convertedVisits,
        title: "wa.ao.graph.converted.visits",
        tooltip: "wa.ao.graph.converted.visits.tooltip",
        iconName: "lead-generator",
        format: "minVisitsAbbr",
    },
    {
        metric: CONVERSION_METRICS.conversionRate,
        title: "wa.ao.conversionrate",
        tooltip: "wa.ao.conversionrate.tooltip",
        iconName: "funnel-empty",
        format: "percentagesign:1",
    },
];

const abbreviateVisits = minVisitsAbbrFilter();
const formatPercent = percentageSignFilter();
const formatPercentagePoints = simplePercentageFilter();

export const formatValue = (value: number | null | undefined, metric: ConversionMetric): string =>
    metric === CONVERSION_METRICS.conversionRate
        ? String(formatPercent(Number(value ?? 0), 1))
        : String(abbreviateVisits(Number(value ?? 0)));

/** Visits change is a ratio (%); conversion rate change is a percentage-point difference (pp). */
export const formatChange = (value: number, metric: ConversionMetric): string =>
    metric === CONVERSION_METRICS.conversionRate
        ? `${formatPercentagePoints(value, 1)}pp`
        : String(formatPercent(value, 2));
